"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGetnetTransactionConverter = void 0;
exports.IGetnetTransactionConverter = {
    toFirestore(transaction) {
        return transaction;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const IGetnetTransaction = {
            id: data.id,
            idEmpresa: data.idEmpresa,
            token: data.token,
            estado: data.estado,
            UserId: data.UserId,
            comprobante: data.comprobante,
            timestampIniciacion: data.timestampIniciacion,
            TransactionId: data.TransactionId,
            aprobado: data.aprobado,
            ticket: data.ticket,
            lote: data.lote,
            EmvApplicationId: data.EmvApplicationId,
            nroAutorizacvion: data.nroAutorizacvion,
            mensajeMostrar: data.mensajeMostrar,
            accion: data.accion,
            idDocumento: data.idDocumento,
            tipoDocumento: data.tipoDocumento,
            Voucher: data.Voucher,
            cancelada: data.cancelada,
            idFixedTransaccionCancela: data.idFixedTransaccionCancela,
            Transaccion: {
                Configuracion: { ModoEmulacion: data.Transaccion.Configuracion?.ModoEmulacion ?? 0 },
                EmpCod: data.Transaccion.EmpCod,
                FacturaConsumidorFinal: data.Transaccion.FacturaConsumidorFinal,
                EmpHASH: data.Transaccion.EmpHASH,
                FacturaMonto: data.Transaccion.FacturaMonto,
                FacturaMontoGravado: data.Transaccion.FacturaMontoGravado,
                FacturaMontoIVA: data.Transaccion.FacturaMontoIVA,
                FacturaNro: data.Transaccion.FacturaNro,
                MonedaISO: data.Transaccion.MonedaISO,
                Monto: data.Transaccion.Monto,
                Operacion: data.Transaccion.Operacion,
                TermCod: data.Transaccion.TermCod,
                Extendida: data.Transaccion.Extendida,
                TicketOriginal: data.Transaccion.TicketOriginal
            }
        };
        return IGetnetTransaction;
    }
};
